import { useEffect, useRef } from 'react';

import { useParams } from 'react-router-dom';

import { useClickstreamCallback } from '@zenbusiness/application-commons-clickstream';
import { useCartContents } from '@zenbusiness/application-commons-ecommerce';
import { usePriceList } from '@zenbusiness/application-commons-pricelist';

import useFlowConfig from '#client/hooks/flow/useFlowConfig';
import priceListProductMapper from '#client/utils/clickstream/priceListProductMapper';

/**
 * This component ensures that clickstream fires a Product Viewed on product page load
 *
 * @component
 */
function TrackProductView() {
  const { getPageConfig } = useFlowConfig();
  const { flowPage } = useParams();
  const { getItem: getCartItem } = useCartContents();
  const { get: getProducts } = usePriceList();
  const trackProductViewed = useClickstreamCallback('productViewed');
  const cartFormationPlanProduct = useRef(null);

  // Cache the current formation plan product in the cart
  useEffect(() => {
    const planServiceName = getCartItem({ hasFormation: true })?.serviceName;
    if (planServiceName) {
      cartFormationPlanProduct.current = getProducts(planServiceName);
    }
  }, [getCartItem, getProducts]);

  // Track product viewed events
  useEffect(() => {
    const currentPageConfig = getPageConfig(flowPage);
    const currentPageProducts = getProducts(currentPageConfig.services);
    currentPageProducts.forEach((product) => {
      trackProductViewed(
        priceListProductMapper({
          product,
          cartFormationPlanProduct: cartFormationPlanProduct.current
        })
      );
    });
  }, [flowPage, getPageConfig, getProducts, trackProductViewed]);

  return false;
}

export default TrackProductView;
